"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const StyledIcon_1 = require("components/Dashboard/Modals/StyledIcon");
const StyledToast_1 = require("./StyledToast");
const StyledToastText_1 = require("./StyledToastText");
const react_bootstrap_1 = require("react-bootstrap");
const Toast = ({ display, status, text }) => {
    return (react_1.default.createElement(react_bootstrap_1.Fade, { in: display },
        react_1.default.createElement(StyledToast_1.StyledToast, { status: status },
            status === 'success' ? (
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-check-circle', size: '16px', white: true })) : (
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-x-circle', size: '16px', white: true })),
            react_1.default.createElement(StyledToastText_1.StyledToastText, null, text))));
};
exports.default = Toast;
